import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import UserSection from '../../Profile/UserSection';
import {Menu, Logo, ThemeContext} from '..';
import logoImg from '../../../images/logo.png';

const Header = (props) => {
  const {
    application: {ableToSendGiftsForFree},
    auth,
    onLogout,
    router,
    user,
    gameConfig: {hasLeaderboard, hasTreasureChest, id: gameId},
  } = props;
  const {isAuthenticated} = auth;
  const isAppDetailsLoaded = Boolean(gameId);
  const currenLocation = router.location.pathname;
  const isGameLocation = currenLocation.indexOf('/game') !== -1;

  const mainNav = [
    {
      text: 'Lobby',
      link: '/lobby',
    },
    {
      text: 'Leaderboard',
      link: '/leaderboard',
      renderInPanel: isGameLocation,
      panelMethod: 'toggleLeaderboard',
      disabled: !hasLeaderboard,
    },
    {
      text: 'Treasure Chest',
      link: '/treasure-chest',
      renderInPanel: isGameLocation,
      panelMethod: 'toggleTreasureChest',
      disabled: !hasTreasureChest,
    },
  ];

  return (
    <ThemeContext.Consumer>
      {theme => (
        <header className="header">
          <Logo imageUrl={logoImg} url="#"/>
          {isAuthenticated && isAppDetailsLoaded && (
            <nav className="header__nav">
              <Menu activeItem={currenLocation} template={theme} links={mainNav} theme="main"/>
              {!isEmpty(user) && (
                <UserSection
                  ableToSendGiftsForFree={ableToSendGiftsForFree}
                  user={user}
                  onLogout={onLogout}
                />
              )}
            </nav>
          )}
        </header>
      )}
    </ThemeContext.Consumer>
  );
};

Header.propTypes = {
  application: PropTypes.shape({
    ableToSendGiftsForFree: PropTypes.bool,
  }).isRequired,
  auth: PropTypes.shape({
    isAuthenticated: PropTypes.bool.isRequired,
  }).isRequired,
  gameConfig: PropTypes.shape({}).isRequired,
  onLogout: PropTypes.func.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  user: PropTypes.shape().isRequired,
};

export default Header;
